import { Outlet } from "react-router-dom";
import AdminRouteLayout from "../../navigation/AdminRouteLayout";

const PostRoot = () => {
  return (
    <AdminRouteLayout>
      <Outlet />
    </AdminRouteLayout>
  );
};

export default PostRoot;
